<script lang="ts">
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from '../../../../../services/i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Stores
		import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['button', 'switch'];
	const _input_options_i18n = ['working_type_button', 'working_type_switch'];

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	$: inputs_counter = Object.keys($settingsStore ?? {}).reduce((r, v) => {
		return v.includes('input') ? (r = r + 1) : r;
	}, 0);

	let inputTypes: { 0?: string; 1?: string; 2?: string; 3?: string } = {},
		loading = false,
		cache;
	const channel = device.channel;

	onMount(() => {
		const isOdd = channel % 2;
		for (let count of Array(inputs_counter).keys()) {
			//so it was needed to change all input based on device channel types with one command for rollers
			if ((isOdd === 0 && count < 2) || (isOdd === 1 && count > 1)) {
				inputTypes[count] = settings[`input:${count}`].type;
			}
		}

		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		for (let count of Object.keys(inputTypes)) {
			inputTypes[count] = value;
		}
	};

	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			let isok = false;
			loading = true;
			for (let input in inputTypes) {
				let params = { id: input, config: { type: inputTypes[input] } };

				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

				if (res.isok) {
					settings[`input:${input}`].type = inputTypes[input];
					isok = true;
					cache[input] = inputTypes[input];
				} else {
					toast.open({
						type: 'danger',
						title: $format('input_type_err_toast') || 'Error! Could not change input mode.',
					});
					isok = false;
					inputTypes[input] = cache[input];
				}
				loading = false;
			}
			if (isok)
				toast.open({
					type: 'success',
					title: $format('input_type_scc_toast', {
						values: {
							mode_value: $format(
								_input_options_i18n.find((option) =>
									option.includes(Object.values(inputTypes)[0]),
								),
							),
						},
					}),
				});
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		value={Object.values(inputTypes)[index]}
		on:click={() => setInputType(option)}
		id="radio-l4nq3x1"
	>
		{$format(_input_options_i18n[index])}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
